// SPDX-FileCopyrightText: Copyright 2024 Dash0 Inc.

import { ReactNode } from "react";

import { cn } from "@/lib/utils";

type SectionHeadingProps = {
	children: ReactNode;
	className?: string;
};

export function SectionHeading({ children, className }: SectionHeadingProps) {
	return <h2 className={cn("mt-8 pt-2 text-[15px] mb-4", className)}>{children}</h2>;
}
